"use strict";

function timeout(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

module.exports = timeout;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/utils/timeout.js
 ** module id = 562
 ** module chunks = 0
 **/